<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <CustomChart
        ref="chart"
        :data="functionData"
        @column-update="getClientAccountingParams"
      />
    </div>
    <SearchTable
      ref="table"
      :key="accountingTableKey"
      :header="{
        title: 'Računovodstvo',
        icon: 'account_balance',
        class: 'md-card-header-brand',
      }"
      :queriedData="payments"
      :metaData="metaData"
      :getItems="getClientAccountingParams"
      :params="params"
      :sortBy="'id'"
      :openItem="openClient"
    />
    <div class="payment-card-container md-layout-item md-size-100">
      <Payment
        v-if="selectedPayment !== null"
        setClient
        :payment="selectedPayment"
        :cash="$route.query.filter === 'cash'"
        :mode="mode"
        :client="selectedClient"
        @saved="getClientAccountingParams"
        @close="selectedPayment = null"
      />
    </div>
    <SearchTable
      ref="outPaymentsTable"
      :key="outPaymentTableKey"
      v-if="$route.query.id && outPaymentsMetaData"
      class="md-layout-item md-size-50 md-large-size-100"
      :header="{
        title: 'Dobavljač',
        icon: 'arrow_back',
        class: 'md-card-header-danger',
      }"
      :queriedData="outPayments"
      :metaData="outPaymentsMetaData"
      :getItems="getOutPayments"
      :params="outPaymentsParams"
      :queryable="false"
      :sortBy="'dateSigned'"
      :newItem="newOutPayments"
      :openItem="openOutPayments"
      :forEachSelected="[
        {
          label: 'Briši',
          class: 'md-danger',
          icon: 'delete',
          function: deleteOutPayments,
        },
      ]"
    >
      <div slot="header" class="ml-auto">
        <md-field>
          <label> Početno stanje € dobavljač </label>
          <md-input
            v-model="outPaymentsMetaData.startDebtTo"
            type="number"
            step="0.01"
            min="0"
            @blur="setStartDebt('to')"
          >
          </md-input>
        </md-field>
      </div>
    </SearchTable>
    <SearchTable
      ref="inPaymentsTable"
      :key="inPaymentTableKey"
      v-if="$route.query.id && inPaymentsMetaData"
      class="md-layout-item md-size-50 md-large-size-100"
      :header="{
        title: 'Kupac',
        icon: 'arrow_forward',
        class: 'md-card-header-green',
      }"
      :queriedData="inPayments"
      :metaData="inPaymentsMetaData"
      :getItems="getPayments"
      :params="inPaymentsParams"
      :sortBy="'dateSigned'"
      :newItem="newInPayments"
      :openItem="openInPayments"
      :queryable="false"
      :forEachSelected="[
        {
          label: 'Briši',
          class: 'md-danger',
          icon: 'delete',
          function: deleteInPayments,
        },
      ]"
    >
      <div slot="header" class="ml-auto">
        <md-field>
          <label> Početno stanje € kupac </label>
          <md-input
            v-model="inPaymentsMetaData.startDebtFrom"
            type="number"
            step="0.01"
            min="0"
            @blur="setStartDebt('from')"
          >
          </md-input>
        </md-field>
      </div>
    </SearchTable>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import SearchTable from '@/components/SearchTable.vue';
import Payment from '@/components/Payment.vue';
import services from '@/api/services';
import api from '@/api/api.js';
import CustomChart from '@/components/Cards/CustomChart.vue';
import { cases } from '@/utils/helpers';

export default {
  components: {
    SearchTable,
    Payment,
    CustomChart,
  },
  data() {
    return {
      payments: [],
      metaData: null,
      params: {
        id: null,
        name: '',
        outDebt: [null, null],
        outPay: [null, null],
        outDebtLeft: [null, null],
        inDebt: [null, null],
        inPay: [null, null],
        inDebtLeft: [null, null],
        total: [null, null],
        lastDate: [null, null],
      },
      selectedClient: null,
      inPayments: [],
      inPaymentsMetaData: null,
      inPaymentsParams: {
        name: null,
        amount: [null, null],
        dateSigned: [null, null],
      },
      outPayments: [],
      outPaymentsMetaData: null,
      outPaymentsParams: {
        name: null,
        amount: [null, null],
        dateSigned: [null, null],
      },
      mode: 'outPayment',
      selectedPayment: null,
      accountingTableKey: 0,
      outPaymentTableKey: 100,
      inPaymentTableKey: 200,
      functionData: {
        labels: [],
        series: [],
        legend: [],
      },
    };
  },
  methods: {
    getClientAccountingParams(printTable = false) {
      const offset = this.metaData ? this.$refs.table.from : 0;
      const limit = this.metaData ? this.$refs.table.pagination.perPage : 75;
      const sortBy = this.metaData ? this.$refs.table.currentSort : null;
      const sortOrder = this.metaData
        ? this.$refs.table.currentSortOrder
        : null;
      const columns = this.metaData ? this.$refs.chart.columns : 12;
      const mode = this.metaData ? this.$refs.chart.mode : 'Bar';
      api
        .get(services.expenses.getClientAccountingParams, {
          getClientAccountingParams: true,
          params: this.params,
          offset,
          limit,
          sortBy,
          filter: this.$route.query.filter ? this.$route.query.filter : null,
          sortOrder,
          columns,
          mode,
          printTable,
        })
        .then((data) => {
          this.payments = data.data;
          this.metaData = data.metaData;
          if (data.metaData.labels)
            this.functionData.labels = data.metaData.labels;
          if (data.metaData.data) this.functionData.series = data.metaData.data;
          if (data.metaData.legend)
            this.functionData.legend = data.metaData.legend;

          if (this.$refs.chart) this.$refs.chart.updateChart();
          if (this.$route.query.id && !printTable) {
            this.getPayments();
            this.getOutPayments();
          }
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    openClient(value) {
      this.selectedClient = value;
      const query = Object.assign({}, this.$route.query, { id: value.id });
      this.$router.push({ path: 'accounting', query });
      this.getPayments();
      this.getOutPayments();
    },
    setStartDebt(direction) {
      const requestParams = {
        id: this.selectedClient.id,
        setStartDebt: true,
        direction,
        amount:
          direction === 'to'
            ? this.outPaymentsMetaData.startDebtTo
            : this.inPaymentsMetaData.startDebtFrom,
      };
      if (this.$route.query.filter === 'cash') requestParams.cash = true;
      api
        .post(services.clients.setStartDebt, requestParams)
        .then(() => {
          this.getClientAccountingParams();
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    getPayments(printTable = false) {
      const readFromTable =
        this.inPaymentsMetaData && this.$refs.inPaymentsTable ? true : false;
      const offset = readFromTable ? this.$refs.inPaymentsTable.from : 0;
      const limit = readFromTable
        ? this.$refs.inPaymentsTable.pagination.perPage
        : 75;
      const sortBy = readFromTable
        ? this.$refs.inPaymentsTable.currentSort
        : null;
      const sortOrder = readFromTable
        ? this.$refs.inPaymentsTable.currentSortOrder
        : null;
      api
        .get(services.payments.getPayments, {
          getPayments: true,
          clientId: this.$route.query.id,
          params: this.inPaymentsParams,
          offset,
          limit,
          sortBy,
          filter: this.$route.query.filter ? this.$route.query.filter : null,
          sortOrder,
          printTable,
        })
        .then((data) => {
          this.inPayments = data.data;
          this.inPaymentsMetaData = data.metaData;
          this.selectedClient = {
            id: this.$route.query.id,
            name: data.metaData.name,
          };
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    newInPayments() {
      this.mode = 'inPayment';
      this.selectedPayment = {
        dateSigned: null,
        amount: null,
        direction: 'in',
        comment: null,
      };
    },
    openInPayments(value) {
      let id;
      if ((id = value.id.match(/offer_(in|out)_(\d*)/))) {
        id = id[2];
        return Swal.fire({
          title: 'Otvori fakturu?',
          text: `Da li ste sigurni da želite da otvorite fakturu ${value.name}?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'md-button md-info btn-fill',
          cancelButtonClass: 'md-button btn-fill',
          confirmButtonText: 'Otvori',
          cancelButtonText: 'Otkaži',
          buttonsStyling: false,
        }).then((data) => {
          let routeData;
          if (data.value) {
            const query = { id };
            if (this.$route.query.filter === 'cash')
              Object.assign(query, { filter: 'cash' });
            routeData = this.$router.resolve({ path: '/invoices', query });
            window.open(routeData.href, '_blank');
          }
        });
      } else {
        api
          .get(services.payments.getPayment, {
            getPayment: true,
            paymentId: value.id,
            clientId: this.$route.query.id,
          })
          .then((data) => {
            this.mode = data.mode;
            this.selectedPayment = data;
          })
          .catch((error) => {
            this.alertError(error);
          });
      }
    },

    // Out Payments from here
    getOutPayments(printTable = false) {
      const readFromTable =
        this.outPaymentsMetaData && this.$refs.outPaymentsTable ? true : false;
      const offset = readFromTable ? this.$refs.outPaymentsTable.from : 0;
      const limit = readFromTable
        ? this.$refs.outPaymentsTable.pagination.perPage
        : 75;
      const sortBy = readFromTable
        ? this.$refs.outPaymentsTable.currentSort
        : null;
      const sortOrder = readFromTable
        ? this.$refs.outPaymentsTable.currentSortOrder
        : null;
      api
        .get(services.expenses.getOutPayments, {
          getPayments: true,
          clientId: this.$route.query.id,
          params: this.outPaymentsParams,
          offset,
          limit,
          sortBy,
          filter: this.$route.query.filter ? this.$route.query.filter : null,
          sortOrder,
          printTable,
        })
        .then((data) => {
          this.outPayments = data.data;
          this.outPaymentsMetaData = data.metaData;
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    newOutPayments() {
      this.mode = 'outPayment';
      this.selectedPayment = {
        dateSigned: null,
        amount: null,
        direction: 'in',
        comment: null,
      };
    },
    openOutPayments(value) {
      let id;
      if ((id = value.id.match(/expense_(\d*)/))) {
        id = id[1];
        return Swal.fire({
          title: 'Otvori fakuru?',
          text: `Da li ste sigurni da želite da otvorite ulaznu fakturu pod šifrom ${id}?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'md-button md-info btn-fill',
          cancelButtonClass: 'md-button btn-fill',
          confirmButtonText: 'Otvori',
          cancelButtonText: 'Otkaži',
          buttonsStyling: false,
        }).then((data) => {
          let routeData;
          if (data.value) {
            const query = { id };
            if (this.$route.query.filter === 'cash')
              Object.assign(query, { filter: 'cash' });
            routeData = this.$router.resolve({ path: '/expenses', query });
            window.open(routeData.href, '_blank');
          }
        });
      } else {
        api
          .get(services.payments.getPayment, {
            getPayment: true,
            paymentId: value.id,
            clientId: this.$route.query.id,
          })
          .then((data) => {
            this.mode = data.mode;
            this.selectedPayment = data;
          })
          .catch((error) => {
            this.alertError(error);
          });
      }
    },

    deleteInPayments(items) {
      const ids = items.map((el) => el.id);
      return Swal.fire({
        title: 'Obriši uplate?',
        text: `Da li ste sigurni da želite da obrišete ${ids.length} ${cases(
          ids.length,
          'uplatu',
          'uplate',
          'uplata',
        )}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-danger btn-fill',
        cancelButtonClass: 'md-button btn-fill',
        confirmButtonText: 'Obriši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then((data) => {
        if (data.value) {
          (() => {
            if (ids.length >= 5) {
              return Swal.fire({
                title: 'Obriši uplate?',
                text: `Označili ste ${ids.length} ${cases(
                  ids.length,
                  'uplatu',
                  'uplate',
                  'uplata',
                )} za brisanje. Potvrdite još jednom da želite da nastavite.`,
                type: 'warning',
                showCancelButton: true,
                cancelButtonClass: 'md-button btn-fill',
                confirmButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: 'Obriši!',
                cancelButtonText: 'Otkaži',
                buttonsStyling: false,
              });
            } else {
              return Promise.resolve(data);
            }
          })().then((data) => {
            if (data.value) {
              api
                .post(services.payments.deletePayments, {
                  deletePayments: true,
                  ids: ids.filter((el) => !el.match(/^offer/)),
                })
                .then(() => {
                  this.getClientAccountingParams();
                  this.$refs.inPaymentsTable.removeChecked();
                  if (ids.find((el) => el.match(/^offer/)))
                    Swal.fire({
                      title: 'Info!',
                      text: 'Označili ste jedan ili više linkova koji vode van ove stranice. Da biste izbrisali ove redove, potrebno je da to uradite na njihovoj određenoj stranici',
                      type: 'danger',
                      confirmButtonClass: 'md-button md-info btn-fill',
                      buttonsStyling: false,
                    });
                })
                .catch((error) => {
                  this.alertError(error);
                });
            }
          });
        }
      });
    },
    deleteOutPayments(items) {
      const ids = items.map((el) => el.id);
      return Swal.fire({
        title: 'Obriši isplatu?',
        text: `Da li ste sigurni da želite da obrišete ${ids.length} ${cases(
          ids.length,
          'isplatu',
          'isplate',
          'isplata',
        )}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-danger btn-fill',
        cancelButtonClass: 'md-button btn-fill',
        confirmButtonText: 'Obriši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then((data) => {
        if (data.value) {
          (() => {
            if (ids.length >= 5) {
              return Swal.fire({
                title: 'Obriši isplate?',
                text: `Označili ste ${ids.length} ${cases(
                  ids.length,
                  'isplatu',
                  'isplate',
                  'isplata',
                )} za brisanje. Potvrdite još jednom da želite da nastavite.`,
                type: 'warning',
                showCancelButton: true,
                cancelButtonClass: 'md-button btn-fill',
                confirmButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: 'Obriši!',
                cancelButtonText: 'Otkaži',
                buttonsStyling: false,
              });
            } else {
              return Promise.resolve(data);
            }
          })().then((data) => {
            if (data.value) {
              api
                .post(services.payments.deletePayments, {
                  deletePayments: true,
                  ids: ids.filter((el) => !el.match(/^expense/)),
                })
                .then(() => {
                  this.getClientAccountingParams();
                  this.$refs.outPaymentsTable.removeChecked();
                  if (ids.find((el) => el.match(/^expense/)))
                    Swal.fire({
                      title: 'Info!',
                      text: 'Označili ste jedan ili više linkova koji vode van ove stranice. Da biste izbrisali ove redove, potrebno je da to uradite na njihovoj određenoj stranici',
                      type: 'danger',
                      confirmButtonClass: 'md-button md-info btn-fill',
                      buttonsStyling: false,
                    });
                })
                .catch((error) => {
                  this.alertError(error);
                });
            }
          });
        }
      });
    },
  },
  mounted() {
    this.getClientAccountingParams();
  },
  watch: {
    $route(to, from) {
      if (to.query.filter !== from.query.filter) {
        this.getClientAccountingParams();
        this.accountingTableKey++;
        this.outPaymentTableKey++;
        this.inPaymentTableKey++;
      }
      this.selectedPayment = null;
    },
    selectedClient(to) {
      if (to.name) {
        document.title = `${to.name} - ${this.$route.meta.title}  - WebToPrint`;
      }
    },
    // "metaData.columnParams": {
    //   handler: function (to, from) {
    //     if (to && (!from || to.length !== from.length)) this.reloading++;
    //   },
    //   deep: true,
    // },
  },
};
</script>

<style>
/* .md-input:hover {
  box-shadow: 0px 0px 2px 2px #cecece;
} */
.span-title {
  margin-left: 1em;
  display: inline;
}

.md-card.payment-card {
  /* display: block; */
  width: 100%;
  position: relative;
  left: 0%;
  /* margin: 0px auto 0px 0px !important; */
  transition: all 0.5s ease-in-out;
}

.md-card.payment-card.payment-card-right {
  /* margin: 0px 0px 0px auto !important; */
  left: 0px;
}
.leave-button {
  /* float: right; */
  position: absolute;
  top: 0.7em;
  right: 0.7em;
}
@media (min-width: 1280px) {
  .md-card.payment-card {
    width: 50%;
  }
  .md-card.payment-card.payment-card-right {
    left: 50%;
  }
}
</style>
